"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _classnames = _interopRequireDefault(require("classnames"));

var _HTMLContent = _interopRequireDefault(require("../common/HTMLContent"));

var _withSSIContent = require("../common/withSSIContent");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var SSIFooter = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(SSIFooter, _Component);

  var _super = _createSuper(SSIFooter);

  function SSIFooter() {
    (0, _classCallCheck2.default)(this, SSIFooter);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(SSIFooter, [{
    key: "render",
    value: function render() {
      return (0, _preact.h)(_HTMLContent.default, {
        html: this.props.html,
        className: (0, _classnames.default)(['ssi', 'ssi-footer', 'footer-area'])
      });
    }
  }]);
  return SSIFooter;
}(_preact.Component);

var _default = (0, _withSSIContent.withSSIContent)(SSIFooter);

exports.default = _default;